'use client';

import { useEffect, useState } from 'react';

import { clsx } from 'clsx';

import { enquiryFormDict } from '@monoimin/intl';

import { LinkButton, Icons } from '@monoimin/atoms';

import { FormConfig } from '@monoimin/forms/gravity-form/types';

import { PROJECT_SLUG } from '@monoimin/constants';

import { ModalButton } from './ModalButton';

import { FormWithExpert } from './FormWIthExpert';

import type { Person, CommonMessages, EnOrRuLocale } from '@monoimin/sb-types';

import type { MeetingData } from '../types';

type ContactButtonsProps = {
  locale: EnOrRuLocale;
  messages: CommonMessages;
  phoneLink: MeetingData['phoneLink'];
  analyticsName: string;
  expert: Person;
  formConfig?: FormConfig | null;
};

export const ContactButtons = ({
  locale,
  messages,
  phoneLink,
  expert,
  formConfig,
}: ContactButtonsProps) => {
  const havePhoneLink = phoneLink?.href && phoneLink?.title;

  const [isScrolledToFooter, setIsScrolledToFooter] = useState(false);
  // проверяем что футер уже видно во вюпорте обновляем стейт и по нему скрываем кнопку
  useEffect(() => {
    const footer = document.getElementById('footer');
    if (!footer) {
      console.log('Footer element not found');
      return;
    }
    const footerHeight = footer.offsetHeight;
    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log('Footer is intersecting:', entry.isIntersecting);
        setIsScrolledToFooter(entry.isIntersecting);
      },
      { threshold: 0.1, rootMargin: `-${footerHeight / 2}px` }
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!formConfig?.id || isScrolledToFooter) return null;
  const isPsy = PROJECT_SLUG === 'passportivity';
  // TODO перенести урл где то в датасорсвне проекта, пока не определились где мы храним такие веши в upstash github gits storyblok datasource  либо в другом месте.
  const linkButtonUrl = isPsy
    ? ''
    : 'https://api.whatsapp.com/send?phone=41784900878&text=Hello!';
  return (
    <div
      className={clsx(
        'popup-buttons flex gap-3 overflow-hidden w-full relative',
        isScrolledToFooter && 'opacity-0'
      )}
    >
      <ModalButton
        theme='dark'
        size='small'
        className={clsx('max-w-full w-full', {
          'h-12 justify-center': isPsy,
          'min-w-full lg:w-full': linkButtonUrl,
        })}
        linkButtonUrl={linkButtonUrl}
        modalCard={
          <div className='container relative'>
            <FormWithExpert
              title={enquiryFormDict[locale]['realEstateEnquiry']}
              description={enquiryFormDict[locale]['realEstateEnquiryDesc']}
              formConfig={formConfig}
              locale={locale}
              expert={expert}
            />
          </div>
        }
      >
        {messages.enquireNow}
      </ModalButton>
      {havePhoneLink && (
        <LinkButton
          href={phoneLink.href}
          size='small'
          theme='dark'
          className='lg:hidden max-w-[48px] max-h-12 group'
        >
          <Icons icon='phone' isInteractive className='bg-white' />
        </LinkButton>
      )}
    </div>
  );
};
